import CheckMark from 'components/Globals/CheckMark';
import * as S from './CompanyFranchiseTitleRankStyles';

export interface CompanyFranchiseTitleRankProps {
  companyRanking: number;
  showRank?: boolean;
  rankDataCy?: string;
}

const CompanyFranchiseTitleRank = ({
  companyRanking,
  showRank = true,
  rankDataCy = '',
}: CompanyFranchiseTitleRankProps) => (
  <S.RankWrapper data-cy={rankDataCy}>{showRank ? companyRanking : <CheckMark />}</S.RankWrapper>
);

export default CompanyFranchiseTitleRank;
